import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './InfoTilesSection.css';

export const InfoTilesSection = ({
  title,
  dek,
  tiles,
  className,
  backgroundColor = 'white',
  twoColumn,
}) => {
  const classNames = cx(
    'info-tiles-section',
    `info-tiles-section--${backgroundColor}`,
    { 'info-tiles-section--twoColumn': twoColumn },
    className
  );

  return (
    <div className={classNames}>
      {typeof title === 'string' ? (
        <h2 className="info-tiles-section__title zui__h2">{title}</h2>
      ) : (
        <>{title}</>
      )}
      {dek && <p className="info-tiles-section__dek">{dek}</p>}
      <div className="info-tiles-section__tiles">
        {tiles.map((tile, i) => (
          <div className="info-tiles-section__tile" key={i}>
            {tile}
          </div>
        ))}
      </div>
    </div>
  );
};

InfoTilesSection.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  tiles: PropTypes.arrayOf(PropTypes.node).isRequired,
  dek: PropTypes.string,
  className: PropTypes.string,
  twoColumn: PropTypes.bool,
  backgroundColor: PropTypes.oneOf([
    'white',
    'rose',
    'secondary-background-gray',
    'light-periwinkle',
    'highlight-blue',
  ]), // these correspond to var names in src/styles/common/_variables.css
};

export default InfoTilesSection;
